import { useEffect, useRef, useState } from 'react';
import { UMButton, UMIcon, UMR } from '../_components';
import { SELECTION_COLORS, SELECTION_COLORS_EXTENDED } from './selectionForm';

// CustomColorPicker.vue + ColorPickerPopover.vue (production) : boîte 80×32, pastille 20×20,
// grille de 10 colonnes 20×20 (gap 5), « Voir plus / moins de couleurs », « Fermer ».
const CSS =
  `.sel-color-box:hover{background:${UMR.hover}!important}` +
  `.sel-swatch:hover,.sel-swatch[aria-pressed="true"]{border:3px solid ${UMR.textStrong}!important}` +
  '.sel-color-more:hover{text-decoration:underline}';

export function SelectionColorPicker({ value, onChange }: { value: string; onChange: (color: string) => void }) {
  const [open, setOpen] = useState(false);
  const [more, setMore] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);
  const colors = more ? SELECTION_COLORS_EXTENDED : SELECTION_COLORS;
  return (
    <div ref={ref} style={{ position: 'relative', width: 80 }}>
      <style>{CSS}</style>
      <button type="button" className="sel-color-box" aria-label={`Couleur de la sélection : ${value}`}
        aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen((o) => !o)}
        style={{
          position: 'relative', width: 80, height: 32, boxSizing: 'border-box', padding: '0 16px',
          border: `1px solid ${UMR.borderInput}`, borderRadius: 0, background: UMR.white,
          display: 'flex', alignItems: 'center', cursor: 'pointer',
        }}>
        <span aria-hidden="true" data-testid="selection-color-indicator" style={{ width: 20, height: 20, background: value }} />
        <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', display: 'flex', pointerEvents: 'none' }}>
          <UMIcon name="expand_more" family="icons" size={24} color={UMR.black} />
        </span>
      </button>
      {open && (
        // Placement à gauche (et non bottom-end) pour rester dans le panneau de 300 px.
        <div role="dialog" aria-label="Choisir une couleur" style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 20, background: UMR.white,
          border: `1px solid ${UMR.borderInput}`, padding: 10, display: 'flex', flexDirection: 'column', gap: 10,
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(10, 20px)', gap: 5 }}>
            {colors.map((c) => (
              <button key={c} type="button" className="sel-swatch" aria-label={`Couleur ${c}`} aria-pressed={c === value}
                onClick={() => onChange(c)}
                style={{ width: 20, height: 20, boxSizing: 'border-box', padding: 0, border: 'none', borderRadius: 0, background: c, cursor: 'pointer' }} />
            ))}
          </div>
          <button type="button" className="sel-color-more" onClick={() => setMore((m) => !m)}
            style={{ alignSelf: 'flex-end', background: 'none', border: 'none', padding: 0, color: UMR.blueLink, fontFamily: UMR.font, fontSize: 14, lineHeight: '21px', cursor: 'pointer' }}>
            {more ? 'Voir moins de couleurs' : 'Voir plus de couleurs'}
          </button>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <UMButton variant="secondary" onClick={() => setOpen(false)}>Fermer</UMButton>
          </div>
        </div>
      )}
    </div>
  );
}
